
// if (this.userSession.planId === 0) return false
// return this.userSession.planId < 9

const isUserPlanOld = planId => planId === 0 ? false : (planId < 9)

const getPlanDiscount = (planId = 0) => {
  const discount = [
    0, // 'Plano Grátis',
    0, // 'Plano 2',
    0, // 'Plano 3',
    0, // 'Plano 4',
    0, // 'Plano 5',
    0, // 'Plano 2',
    0, // 'Plano 3',
    0, // 'Plano 4',
    0, // 'Plano 5',
    0, // 'Plano Bronze',
    0, // 'Plano Silver',
    0, // 'Plano Gold',
    0, // 'Plano Platinum',
    10, // 'Plano Bronze',
    10, // 'Plano Silver',
    10, // 'Plano Gold',
    10, // 'Plano Platinum',
    30, // 'Plano Bronze', // 30 (com 10% de desconto)
    30, // 'Plano Silver', // 30
    30, // 'Plano Gold', // 30
    30, // 'Plano Platinum', // 30
    30, // 'Plano Bronze', // 30
    30, // 'Plano Silver', // 30
    30, // 'Plano Gold', // 30
    30, // 'Plano Platinum', // 30
  ]

  return discount[planId]
}

const getPlanName = (planId = 0, periodo = true) => {
  const plans = [
    'Plano Grátis',
    'Plano 2 (Mensal)',
    'Plano 3 (Mensal)',
    'Plano 4 (Mensal)',
    'Plano 5 (Mensal)',
    'Plano 2 (Anual)',
    'Plano 3 (Anual)',
    'Plano 4 (Anual)',
    'Plano 5 (Anual)',
    'Plano Bronze (Mensal)',
    'Plano Silver (Mensal)',
    'Plano Gold (Mensal)',
    'Plano Platinum (Mensal)',
    'Plano Bronze (Anual)',
    'Plano Silver (Anual)',
    'Plano Gold (Anual)',
    'Plano Platinum (Anual)',
    'Plano Bronze (Mensal)', // 30
    'Plano Silver (Mensal)', // 30
    'Plano Gold (Mensal)', // 30
    'Plano Platinum (Mensal)', // 30
    'Plano Bronze (Anual)', // 30
    'Plano Silver (Anual)', // 30
    'Plano Gold (Anual)', // 30
    'Plano Platinum (Anual)', // 30
  ]

  const plansSemPeriodo = [
    'Plano Grátis',
    'Plano 2',
    'Plano 3',
    'Plano 4',
    'Plano 5',
    'Plano 2',
    'Plano 3',
    'Plano 4',
    'Plano 5',
    'Plano Bronze',
    'Plano Silver',
    'Plano Gold',
    'Plano Platinum',
    'Plano Bronze',
    'Plano Silver',
    'Plano Gold',
    'Plano Platinum',
    'Plano Bronze', // 30
    'Plano Silver', // 30
    'Plano Gold', // 30
    'Plano Platinum', // 30
    'Plano Bronze', // 30
    'Plano Silver', // 30
    'Plano Gold', // 30
    'Plano Platinum', // 30
  ]

  return periodo ? plans[planId] : plansSemPeriodo[planId]
}

const isEmailValid = emailAddress => {
  const email = String(emailAddress).trim()
  return email.length > 0 ? /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(email) : false
}

//
//
//

const planCategoryByPlanId = planId => {
  const planCategories = {
    0: 'free', // Free
    1: 'plano2', // Plano 2 Mensal
    2: 'plano3', // Plano 3 Mensal
    3: 'plano4', // Plano 4 Mensal
    4: 'plano5', // Plano 5 Mensal
    5: 'plano2', // Plano 2 Anual
    6: 'plano3', // Plano 3 Anual
    7: 'plano4', // Plano 4 Anual
    8: 'plano5', // Plano 5 Anual
    9: 'plano2', // Bronze Mensal
    10: 'plano3', // Silver Mensal
    11: 'plano4', // Gold Mensal
    12: 'plano5', // Platinum Mensal
    13: 'plano2', // Bronze Anual
    14: 'plano3', // Silver Anual
    15: 'plano4', // Gold Anual
    16: 'plano5', // Platinum Anual
    17: 'plano2', // Bronze Mensal 30
    18: 'plano3', // Silver Mensal 30
    19: 'plano4', // Gold Mensal 30
    20: 'plano5', // Platinum Mensal 30
    21: 'plano2', // Bronze Anual 30
    22: 'plano3', // Silver Anual 30
    23: 'plano4', // Gold Anual 30
    24: 'plano5', // Platinum Anual 30
  }

  return planCategories[planId]
}

// $limiteDeEscalasPadrao = [ 'free'=>1, 'plano2'=>5, 'plano3'=>10, 'plano4'=>20, 'plano5'=>30 ];
// $limiteDeUsuariosPadrao = [ 'free'=>15, 'plano2'=>30, 'plano3'=>45, 'plano4'=>60, 'plano5'=>200 ];

const scaleLimitByPlanCategory = planCategory => {
  const scalesLimit = { free: 1, plano2: 5, plano3: 10, plano4: 20, plano5: 30 }
  return scalesLimit[planCategory]
}

const userLimitByPlanCategory = planCategory => {
  const usersLimit = { free: 15, plano2: 30, plano3: 45, plano4: 60, plano5: 200 }
  return usersLimit[planCategory]
}

//
//
//

export {
  isUserPlanOld,
  getPlanDiscount,
  getPlanName,
  isEmailValid,
  planCategoryByPlanId,
  scaleLimitByPlanCategory,
  userLimitByPlanCategory,
}
